var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74 7.688c-.5-.5-.885-4.235-.687-4.587l.687-1.045.593-.704L2.927 1h.89l.593.704.594.704.593 1.056.594 1.056.297 1.056-.594 1.056-.297 1.056L6.191 9l2.362 2.5 1.819 1.82 1.181.532h.572l.594-.352.593-.352h.594l.593.352 1.109.704.968.796.477.5.5 1-.5 1-1.07.748-.93.352h-1.147l-1.187-.352-1.166-.748-1.181-.653-1.006-.587L8.053 15l-1.565-1.68-2.671-2.82L2.553 9 1.74 7.688z",
    stroke: "#000",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondStep);
export default __webpack_public_path__ + "static/media/secondStep.0df1422b6d1b4e49cb046dc0d82437cc.svg";
export { ForwardRef as ReactComponent };